"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpClient = void 0;
var oauth2_client_1 = require("./oauth2-client");
var endpoints_1 = __importDefault(require("./endpoints"));
var metamask_1 = __importStar(require("./metamask"));
var request_1 = __importDefault(require("./request"));
var axios_1 = __importDefault(require("axios"));
var sweetalert2_1 = __importDefault(require("sweetalert2"));
var dialog_1 = __importDefault(require("./provider/utils/dialog"));
var log_1 = __importDefault(require("./provider/utils/log"));
var utils_1 = require("./provider/utils");
var HttpClient = /*#__PURE__*/function () {
  function HttpClient(appId, accessToken, refreshToken, expiresIn, apiHost) {
    var bridgeMetaMask = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
    _classCallCheck(this, HttpClient);
    this.endpoints = new endpoints_1.default();
    this.apiHost = this.endpoints.getApiHost();
    this.confirmUrl = this.endpoints.getConfirmUrl();
    this.bridgeUrl = this.endpoints.getBridgeUrl();
    this.swalPromise = null;
    this.env = '';
    this.txStatus = '';
    this.loadingDialog = sweetalert2_1.default.mixin({});
    this.bridgeMetaMask = true;
    this.bridgeMetaMask = bridgeMetaMask;
    this.endpoints = new endpoints_1.default(apiHost);
    if (apiHost) {
      this.apiHost = apiHost;
    } else {
      this.apiHost = this.endpoints.getApiHost();
    }
    this.confirmUrl = this.endpoints.getConfirmUrl();
    this.bridgeUrl = this.endpoints.getBridgeUrl();
    this.appId = appId;
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    this.oAuth2Client = new oauth2_client_1.Oauth2Client(apiHost);
    var oauthUser = {
      appId: appId,
      accessToken: accessToken,
      refreshToken: refreshToken,
      expiresIn: expiresIn,
      expriesAt: new Date().getTime() + (expiresIn - 5) * 1000
    };
    this.oAuth2Client.setUser(oauthUser);
  }
  _createClass(HttpClient, [{
    key: "handleRefreshToken",
    value: function handleRefreshToken(callback) {
      var _this = this;
      var _a, _b;
      if (new Date().getTime() < ((_a = this.oAuth2Client.oauth2User) === null || _a === void 0 ? void 0 : _a.expriesAt)) {
        if (callback) {
          callback.apply(this);
        }
        return;
      }
      this.oAuth2Client.refreshToken(this.appId, (_b = this.oAuth2Client.oauth2User) === null || _b === void 0 ? void 0 : _b.refreshToken, function (oauth2User) {
        _this.accessToken = oauth2User.accessToken;
        _this.refreshToken = oauth2User.refreshToken || '';
        if (callback) {
          callback.apply(_this);
        }
      });
    }
  }, {
    key: "getBalance",
    value: function getBalance(chainId) {
      var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var headers, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.accessToken
              };
              data = {
                chainId: chainId
              };
              if (address && address.length > 0) {
                data.address = address;
              }
              return _context.abrupt("return", this.post('balance', data));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getLogsAsync",
    value: function getLogsAsync(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.post('get_logs', data));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getTxLogsAsync",
    value: function getTxLogsAsync(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", this.post('get_tx_logs', data));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "post",
    value: function post(method, data) {
      var disableTooltip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var httpMethod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'post';
      var returnObj = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var headers, res, trans, errMsg;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.handleRefreshTokenAsync();
            case 2:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.accessToken
              };
              if (!(httpMethod === 'post')) {
                _context4.next = 9;
                break;
              }
              _context4.next = 6;
              return axios_1.default.post(this.apiHost + "/api/v1/oauth2/" + method, data, {
                headers: headers
              });
            case 6:
              res = _context4.sent;
              _context4.next = 12;
              break;
            case 9:
              _context4.next = 11;
              return axios_1.default.get(this.apiHost + "/api/v1/oauth2/" + method, {
                headers: headers
              });
            case 11:
              res = _context4.sent;
            case 12:
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context4.next = 17;
                break;
              }
              trans = res.data.data;
              if (!returnObj) {
                _context4.next = 16;
                break;
              }
              return _context4.abrupt("return", Promise.resolve(res.data));
            case 16:
              return _context4.abrupt("return", Promise.resolve(trans));
            case 17:
              if (res.status === 200 && res.data) {
                errMsg = res.data.msg;
                if (!disableTooltip) {
                  error(errMsg);
                }
              }
              return _context4.abrupt("return", Promise.reject(res.data));
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "handleRefreshTokenAsync",
    value: function handleRefreshTokenAsync() {
      var _a, _b;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var ret;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(new Date().getTime() < ((_a = this.oAuth2Client.oauth2User) === null || _a === void 0 ? void 0 : _a.expriesAt))) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return", null);
            case 2:
              _context5.next = 4;
              return this.oAuth2Client.refreshTokenAsync(this.appId, (_b = this.oAuth2Client.oauth2User) === null || _b === void 0 ? void 0 : _b.refreshToken);
            case 4:
              ret = _context5.sent;
              if (ret) {
                this.accessToken = ret.accessToken;
                this.refreshToken = ret.refreshToken || '';
              }
              return _context5.abrupt("return", ret);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "sendTx",
    value: function sendTx(domain, chainId, fun, args, succCallback, errCallback, extendParams) {
      var _this2 = this;
      var disableTooltip = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
      var headers = {
        'Content-Type': 'application/json',
        'Access-Token': this.accessToken
      };
      this.handleRefreshToken(function () {
        axios_1.default.post(_this2.apiHost + "/api/v1/oauth2/send_tx", {
          chainId: chainId,
          domain: domain,
          args: args,
          function: fun,
          extendArgs: extendParams
        }, {
          headers: headers
        }).then(function (res) {
          if (res.status === 200 && res.data && res.data.code === 200) {
            if (succCallback) {
              succCallback(res.data.data);
            }
            var trans = res.data.data;
            if (trans.act && trans.act === 'SIGN') {
              if (trans.wallet && trans.wallet === 'METAMASK') {
                _this2.getChainUrl(trans.chainId).then(function (chainObj) {
                  metamask_1.default.sendMetaMaskContractTx(trans, chainObj).then(function (res) {
                    var savedTx;
                    if (res === null || res === void 0 ? void 0 : res.success) {
                      saveTx(_this2.apiHost, _this2.accessToken, 'save_app_tx', res === null || res === void 0 ? void 0 : res.data, false).then(function (savedTx) {
                        if (savedTx == null) {
                          savedTx = {
                            tx: res === null || res === void 0 ? void 0 : res.data.trans.txhash,
                            status: 'SERVER_ERROR',
                            chainId: trans.chainId,
                            domain: trans.domain,
                            data: 'ok',
                            act: 'CREATE'
                          };
                        }
                      });
                    }
                  });
                });
              } else {
                _this2.beforeConfirm(trans);
              }
            }
            if (trans.act && trans.act === 'SUCCESS') {
              var toast = sweetalert2_1.default.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: function didOpen(toast) {
                  toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
                  toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
                }
              });
              toast.fire({
                icon: 'success',
                title: 'Smart contract submit successfully'
              });
            }
          } else if (res.status === 200 && res.data) {
            var errMsg = res.data.msg;
            if (!disableTooltip) {
              error(errMsg);
            }
            if (errCallback) {
              errCallback(errMsg);
            }
          }
        }).catch(function (err) {
          if (errCallback) {
            errCallback(err);
          }
        });
      });
    }
  }, {
    key: "estimateGasAsync",
    value: function estimateGasAsync(domain, chainId, fun, args) {
      var disableTooltip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var extendParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var r, headers, res, trans, errMsg;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              r = new request_1.default(!disableTooltip);
              _context6.prev = 1;
              _context6.next = 4;
              return this.handleRefreshTokenAsync();
            case 4:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.accessToken
              };
              _context6.next = 7;
              return r.instance.post("".concat(this.apiHost, "/api/v1/oauth2/send_tx"), {
                chainId: chainId,
                domain: domain,
                args: args,
                estimateGas: true,
                function: fun,
                extendParams: extendParams
              }, {
                headers: headers
              });
            case 7:
              res = _context6.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context6.next = 13;
                break;
              }
              trans = res.data.data;
              return _context6.abrupt("return", Promise.resolve(trans));
            case 13:
              if (!(res.status === 200 && res.data)) {
                _context6.next = 19;
                break;
              }
              errMsg = res.data.msg;
              error(errMsg);
              return _context6.abrupt("return", Promise.reject({
                status: 'ERROR',
                message: errMsg
              }));
            case 19:
              return _context6.abrupt("return", Promise.reject({
                status: 'ERROR',
                message: 'server error:'
              }));
            case 20:
              _context6.next = 25;
              break;
            case 22:
              _context6.prev = 22;
              _context6.t0 = _context6["catch"](1);
              return _context6.abrupt("return", Promise.reject(_context6.t0.message));
            case 25:
              return _context6.abrupt("return", null);
            case 26:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 22]]);
      }));
    }
  }, {
    key: "sendTxAsync",
    value: function sendTxAsync(domain, chainId, func, args) {
      var disableTooltip = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var extendParams = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var r, headers, res, trans, _res, postData, chainObj, savedTx, toast, errMsg;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!disableTooltip) {
                this.showLoading();
              }
              r = new request_1.default(false);
              _context7.prev = 2;
              _context7.next = 5;
              return this.handleRefreshTokenAsync();
            case 5:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.accessToken
              };
              _context7.next = 8;
              return r.instance.post("".concat(this.apiHost, "/api/v1/oauth2/send_tx"), {
                chainId: chainId,
                domain: domain,
                args: args,
                function: func,
                extendParams: extendParams
              }, {
                headers: headers
              }).then(function (res) {
                return res;
              }, function (res) {
                return {
                  status: res.status
                };
              });
            case 8:
              res = _context7.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context7.next = 63;
                break;
              }
              trans = res.data.data;
              if (!(trans.act && trans.act === 'SIGN')) {
                _context7.next = 61;
                break;
              }
              if (!(this.bridgeMetaMask && (trans.wallet == utils_1.WALLET_TYPES.MM || trans.wallet == utils_1.WALLET_TYPES.WC))) {
                _context7.next = 18;
                break;
              }
              postData = Object.assign(trans, {
                txType: utils_1.TX_TYPE.SEND_CON_TX
              });
              _context7.next = 16;
              return this.polisBridgePage(postData);
            case 16:
              _res = _context7.sent;
              return _context7.abrupt("return", Promise.resolve(_res.data));
            case 18:
              if (!(trans.wallet === utils_1.WALLET_TYPES.MM)) {
                _context7.next = 57;
                break;
              }
              this.txStatus = '';
              _context7.next = 22;
              return this.getChainUrl(trans.chainId);
            case 22:
              chainObj = _context7.sent;
              _context7.next = 25;
              return metamask_1.default.sendMetaMaskContractTx(trans, chainObj, disableTooltip);
            case 25:
              _res = _context7.sent;
              log_1.default.debug('metamak', _res);
              if (!(_res === null || _res === void 0 ? void 0 : _res.success)) {
                _context7.next = 51;
                break;
              }
              _context7.next = 30;
              return saveTx(this.apiHost, this.accessToken, 'save_app_tx', _res === null || _res === void 0 ? void 0 : _res.data, true);
            case 30:
              savedTx = _context7.sent;
              if (!(savedTx == null)) {
                _context7.next = 34;
                break;
              }
              savedTx = {
                tx: _res === null || _res === void 0 ? void 0 : _res.data.trans.txhash,
                status: 'SERVER_ERROR',
                chainId: trans.chainId,
                domain: trans.domain,
                data: 'ok',
                act: 'CREATE',
                value: trans.value
              };
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                reject(savedTx);
              }));
            case 34:
              if (!(this.txStatus !== 'SUCCEED' && this.txStatus !== 'FAILED')) {
                _context7.next = 47;
                break;
              }
              _context7.next = 37;
              return (0, utils_1.sleep)(2000);
            case 37:
              _context7.next = 39;
              return this.queryTxAsync(chainId, _res === null || _res === void 0 ? void 0 : _res.data.trans.txhash, true);
            case 39:
              savedTx = _context7.sent;
              if (!(savedTx && savedTx.status && (savedTx.status === 'SUCCEED' || savedTx.status === 'FAILED'))) {
                _context7.next = 45;
                break;
              }
              this.txStatus = savedTx.status;
              if (!(savedTx.status === 'FAILED')) {
                _context7.next = 45;
                break;
              }
              if (!disableTooltip) {
                this.closeLoading();
              }
              return _context7.abrupt("return", Promise.reject(savedTx));
            case 45:
              _context7.next = 34;
              break;
            case 47:
              if (!disableTooltip) {
                this.closeLoading();
              }
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                resolve(savedTx);
              }));
            case 51:
              error(_res === null || _res === void 0 ? void 0 : _res.data);
              return _context7.abrupt("return", Promise.reject(_res));
            case 53:
              if (_res != null && !disableTooltip) {
                this.closeLoading();
              }
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                return reject(_res);
              }));
            case 57:
              if (!(trans.wallet == utils_1.WALLET_TYPES.WC)) {
                _context7.next = 60;
                break;
              }
              _context7.next = 61;
              break;
            case 60:
              return _context7.abrupt("return", this.beforeConfirm(trans));
            case 61:
              if (trans.act && trans.act === 'SUCCESS' && !disableTooltip) {
                toast = sweetalert2_1.default.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: function didOpen(toast) {
                    toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
                    toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
                  }
                });
                toast.fire({
                  icon: 'success',
                  title: 'Smart contract submit successfully'
                });
              }
              return _context7.abrupt("return", trans);
            case 63:
              if (!(res.status === 200 && res.data)) {
                _context7.next = 69;
                break;
              }
              errMsg = res.data.msg;
              if (!disableTooltip) {
                error(errMsg);
              }
              return _context7.abrupt("return", Promise.reject({
                status: 'ERROR',
                message: errMsg
              }));
            case 69:
              return _context7.abrupt("return", Promise.reject({
                status: 'ERROR',
                message: 'server error:'
              }));
            case 70:
              _context7.next = 75;
              break;
            case 72:
              _context7.prev = 72;
              _context7.t0 = _context7["catch"](2);
              return _context7.abrupt("return", Promise.reject(_context7.t0.message));
            case 75:
              return _context7.abrupt("return", null);
            case 76:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[2, 72]]);
      }));
    }
  }, {
    key: "polisBridgePage",
    value: function polisBridgePage(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var bridgeUrl, postData, confirmWin, self;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              bridgeUrl = this.bridgeUrl;
              postData = {
                walletType: data.wallet,
                domain: data.domain,
                chainId: data.chainId,
                from: data.eth_address,
                function: data.function,
                funcAbi: data.func_abi_sign,
                args: data.args ? data.args : [],
                gas: data.gas,
                gasLimit: data.gasLimit,
                gasPrice: data.gas_price_num,
                fee: data.fee_num,
                feeTxt: data.fee,
                contractAddress: data.contract_address,
                accessToken: this.accessToken,
                value: data.value,
                symbol: data.symbol,
                to: data.to,
                data: data.data ? data.data : '0x',
                act: data.act,
                isMetamask: false,
                isThirdwallet: false,
                nonce: data.nonce,
                chainUrl: '',
                txType: utils_1.TX_TYPE.SEND_CON_TX,
                sdkVer: 1
              };
              log_1.default.debug("sdk v1 postdata:", postData);
              confirmWin = dialog_1.default.fire({
                title: '',
                html: "<iframe src=\"".concat(bridgeUrl, "\" style=\"width: 100%; height: 0px;\" frameborder=\"0\" id=\"polisBridgeIframe\"></iframe>"),
                width: "0px",
                showConfirmButton: false,
                background: '#3A1319',
                didOpen: function didOpen(dom) {
                  document.getElementById('polisBridgeIframe').onload = function () {
                    document.getElementById('polisBridgeIframe').contentWindow.postMessage(postData, bridgeUrl.split('/#')[0]);
                  };
                },
                didClose: function didClose() {
                  window.postMessage({
                    status: 'ERROR',
                    code: 1000,
                    message: 'CANCEL'
                  }, window.location.origin);
                }
              });
              self = this;
              return _context8.abrupt("return", new Promise(function (resolve, reject) {
                function globalMessage(event) {
                  log_1.default.debug("event confirm: ".concat(JSON.stringify(event.data)));
                  if (event.origin !== 'https://polis.metis.io' && event.origin !== 'https://polis-test.metis.io' && event.origin !== 'https://test-polis.metis.io' && event.origin !== 'http://localhost:1024' && event.origin + "/" != self.apiHost && event.origin !== window.location.origin) {
                    return;
                  }
                  if (event.data && event.data.status) {
                    if (event.data.status === 'ERROR' || event.data.status === 'DECLINE' || event.data.status === 'FAILED') {
                      reject(event.data);
                    } else {
                      resolve(event.data);
                    }
                    window.removeEventListener('message', globalMessage, false);
                    dialog_1.default.close(self.swalPromise);
                  }
                }
                window.addEventListener('message', globalMessage, false);
              }));
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "beforeConfirm",
    value: function beforeConfirm(data) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this3 = this;
        var postData, confirmUrl;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              postData = {
                walletType: data.wallet,
                domain: data.domain,
                chainId: data.chainId,
                from: data.eth_address,
                function: data.function,
                funcAbi: data.func_abi_sign,
                args: data.args ? data.args : [],
                gas: data.gas,
                gasLimit: data.gasLimit,
                gasPrice: data.gas_price_num,
                fee: data.fee_num,
                feeTxt: data.fee,
                contractAddress: data.contract_address,
                accessToken: this.accessToken,
                value: data.value,
                symbol: data.symbol,
                to: data.to ? data.to : data.contract_address,
                data: data.data,
                act: data.act,
                isMetamask: false,
                isThirdwallet: false,
                nonce: data.nonce,
                chainUrl: '',
                txType: utils_1.TX_TYPE.SEND_CON_TX,
                sdkVer: 1
              };
              log_1.default.debug("sdk v1 postdata:", postData);
              confirmUrl = this.confirmUrl;
              sweetalert2_1.default.fire({
                title: '<span style="font-size: 24px;font-weight: bold;color: #FFFFFF;font-family: Helvetica-Bold, Helvetica">Request Confirmation</span>',
                html: "<iframe src=\"".concat(this.confirmUrl, "\" style=\"width: 100%; height: 480px;\" frameborder=\"0\" id=\"metisConfirmIframe\"></iframe>"),
                width: '720px',
                showConfirmButton: false,
                background: '#3A1319',
                didOpen: function didOpen(dom) {
                  document.getElementById('metisConfirmIframe').onload = function () {
                    document.getElementById('metisConfirmIframe').contentWindow.postMessage(postData, confirmUrl.split('/#')[0]);
                  };
                },
                didClose: function didClose() {
                  window.postMessage({
                    status: 'ERROR',
                    code: 1000,
                    message: 'CANCEL'
                  }, window.location.origin);
                }
              });
              return _context9.abrupt("return", new Promise(function (resolve, reject) {
                var self = _this3;
                function globalMessage(event) {
                  if (event.origin !== 'https://polis.metis.io' && event.origin !== 'https://polis-test.metis.io' && event.origin !== 'https://test-polis.metis.io' && event.origin !== 'http://localhost:1024' && event.origin !== self.apiHost && event.origin !== window.location.origin) {
                    return;
                  }
                  if (event.data && event.data.status) {
                    if (event.data.status === 'ERROR' || event.data.status === 'DECLINE' || event.data.status === 'FAILED') {
                      reject(event.data);
                    } else {
                      resolve(event.data);
                    }
                    window.removeEventListener('message', globalMessage, false);
                    sweetalert2_1.default.close(self.swalPromise);
                  }
                }
                window.addEventListener('message', globalMessage, false);
              }));
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "queryTx",
    value: function queryTx(chainId, tx, succCallback, errCallback) {
      var _this4 = this;
      var extendParams = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var disableTooltip = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var headers = {
        'Content-Type': 'application/json',
        'Access-Token': this.accessToken
      };
      this.handleRefreshToken(function () {
        axios_1.default.post(_this4.apiHost + "/api/v1/oauth2/query_tx", {
          chainId: chainId,
          tx: tx,
          extendParams: extendParams
        }, {
          headers: headers
        }).then(function (res) {
          if (res.status === 200 && res.data && res.data.code == 200) {
            if (succCallback) {
              succCallback(res.data.data);
            }
            var trans = res.data.data;
            if (trans.tx && trans.act && trans.act == 'SUCCESS') {
              var Toast = sweetalert2_1.default.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: function didOpen(toast) {
                  toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
                  toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
                }
              });
              if (trans.status && trans.status == 'SUCCEED') {
                Toast.fire({
                  icon: 'success',
                  title: 'Smart contract submit successfully'
                });
              } else if (trans.status && trans.status == 'FAILED') {
                Toast.fire({
                  icon: 'warning',
                  title: 'Smart contract submit failed'
                });
              }
            }
          } else if (res.status === 200 && res.data) {
            var errMsg = res.data.msg;
            if (!disableTooltip) {
              error(errMsg);
            }
            if (errCallback) {
              errCallback(errMsg);
            }
          }
        });
      });
    }
  }, {
    key: "queryTxAsync",
    value: function queryTxAsync(chainId, tx, disableTooltip) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var headers, r, res, trans, toast, errMsg;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              headers = {
                'Content-Type': 'application/json',
                'Access-Token': this.accessToken
              };
              _context10.next = 3;
              return this.handleRefreshToken();
            case 3:
              r = new request_1.default(!disableTooltip);
              _context10.next = 6;
              return r.instance.post(this.apiHost + "/api/v1/oauth2/query_tx", {
                chainId: chainId,
                tx: tx
              }, {
                headers: headers
              });
            case 6:
              res = _context10.sent;
              if (!(res.status === 200 && res.data && res.data.code === 200)) {
                _context10.next = 11;
                break;
              }
              trans = res.data.data;
              if (trans.tx && trans.act && trans.act === 'SUCCESS' && !disableTooltip) {
                toast = sweetalert2_1.default.mixin({
                  toast: true,
                  position: 'top-end',
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                  didOpen: function didOpen(toast) {
                    toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
                    toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
                  }
                });
                if (trans.status && trans.status === 'SUCCEED') {
                  toast.fire({
                    icon: 'success',
                    title: 'Smart contract submit successfully'
                  });
                } else if (trans.status && trans.status === 'FAILED') {
                  toast.fire({
                    icon: 'warning',
                    title: 'Smart contract submit failed'
                  });
                }
              }
              return _context10.abrupt("return", trans);
            case 11:
              if (res.status === 200 && res.data) {
                errMsg = res.data.msg;
                if (!disableTooltip) {
                  error(errMsg);
                }
              }
              return _context10.abrupt("return", null);
            case 13:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "closeConfirmDialog",
    value: function closeConfirmDialog() {
      sweetalert2_1.default.close(this.swalPromise);
    }
  }, {
    key: "getChainUrl",
    value: function getChainUrl(chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.post('chainurl', {
                chainId: chainId
              });
            case 2:
              return _context11.abrupt("return", _context11.sent);
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "addTokenToMM",
    value: function addTokenToMM(token) {
      var tokenAddress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tokenDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 18;
      var tokenImage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var chainId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var chainObj, chainNum;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              chainObj = null;
              chainNum = chainId;
              if (typeof token === 'object' && !!token['chainId']) {
                chainNum = token['chainId'];
              }
              if (!(chainNum > 0)) {
                _context12.next = 14;
                break;
              }
              _context12.prev = 4;
              _context12.next = 7;
              return this.getChainUrl("".concat(chainNum));
            case 7:
              chainObj = _context12.sent;
              chainObj['chainId'] = chainNum;
              _context12.next = 14;
              break;
            case 11:
              _context12.prev = 11;
              _context12.t0 = _context12["catch"](4);
              chainObj = null;
            case 14:
              return _context12.abrupt("return", (0, metamask_1.addToken)(token, tokenAddress, tokenDecimals, tokenImage, chainObj));
            case 15:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[4, 11]]);
      }));
    }
  }, {
    key: "getDomain",
    value: function getDomain(name, chainId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", this.post('domains', {
                name: name,
                chainId: chainId
              }));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "createDomain",
    value: function createDomain(param) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this.post('domains/create', param, disableTooltip, 'post', true));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "saveDomainChains",
    value: function saveDomainChains(param) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!param.id) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return", this.post("domains/".concat(param.id, "/save_chains"), param, disableTooltip, 'post', true));
            case 2:
              if (!param.domain) {
                _context15.next = 4;
                break;
              }
              return _context15.abrupt("return", this.post("domains/".concat(param.domain, "/save_chains"), param, disableTooltip, 'post', true));
            case 4:
              return _context15.abrupt("return", Promise.reject('The parameter ID or domain can not be empty'));
            case 5:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "delDomain",
    value: function delDomain(domain) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", this.post("domains/deldomain/".concat(domain), null, disableTooltip, 'get', true));
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "providerCall",
    value: function providerCall(param) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.post('eth_call', param);
            case 2:
              return _context17.abrupt("return", _context17.sent);
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "createDapp",
    value: function createDapp(param) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", this.post('create_applications?access_token=' + this.accessToken, param, disableTooltip, 'post', true));
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "modifyDapp",
    value: function modifyDapp(param) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", this.post('modify_applications?access_token=' + this.accessToken, param, disableTooltip, 'post', true));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "deleteDapps",
    value: function deleteDapps(param) {
      var disableTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", this.post('del_applications?access_token=' + this.accessToken, param, disableTooltip, 'post', true));
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
    }
  }, {
    key: "getDappList",
    value: function getDappList(pageSize, pageIndex) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var method;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              method = 'get_applications?' + this.accessToken + "&page_no=" + pageIndex + "&page_size=" + pageSize;
              return _context21.abrupt("return", this.post(method, null, false, 'get'));
            case 2:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "getDapp",
    value: function getDapp(dappId) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var method;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              method = 'get_application?' + this.accessToken + "&id=" + dappId;
              return _context22.abrupt("return", this.post(method, null, false, 'get'));
            case 2:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
    }
  }, {
    key: "applyToDeveloper",
    value: function applyToDeveloper() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var method;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              method = 'dev_request?' + this.accessToken;
              return _context23.abrupt("return", this.post(method, null, false, 'get'));
            case 2:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
    }
  }, {
    key: "showLoading",
    value: function showLoading() {
      this.loadingDialog.fire({
        html: 'Processing...',
        didOpen: function didOpen() {
          sweetalert2_1.default.showLoading();
        },
        allowOutsideClick: false
      });
    }
  }, {
    key: "closeLoading",
    value: function closeLoading() {
      this.loadingDialog.close();
    }
  }]);
  return HttpClient;
}();
exports.HttpClient = HttpClient;
function error(msg) {
  log_1.default.debug("msg", msg);
  var errMsg = msg;
  if (typeof msg === 'object' && msg.message) {
    errMsg = msg.message;
  }
  var toast = sweetalert2_1.default.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: function didOpen(toast) {
      toast.addEventListener('mouseenter', sweetalert2_1.default.stopTimer);
      toast.addEventListener('mouseleave', sweetalert2_1.default.resumeTimer);
    }
  });
  toast.fire({
    icon: 'error',
    title: errMsg || 'Some errors occured'
  });
}
function saveTx(apiHost, accessToken, method, data, disableDialog) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
    var headers, res, trans, result, _result;
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          headers = {
            'Content-Type': 'application/json',
            'Access-Token': accessToken
          };
          _context24.prev = 1;
          _context24.next = 4;
          return new request_1.default(!disableDialog).instance.post("".concat(apiHost, "/api/v1/oauth2/") + method, data, {
            headers: headers
          });
        case 4:
          res = _context24.sent;
          if (!(res.status === 200 && res.data && res.data.code === 200)) {
            _context24.next = 8;
            break;
          }
          trans = res.data.data;
          return _context24.abrupt("return", trans);
        case 8:
          if (!(res.status === 200 && res.data)) {
            _context24.next = 19;
            break;
          }
          _context24.next = 11;
          return sweetalert2_1.default.fire({
            html: '<div style=\'text-align: left;\'>The transaction was submitted successfully, but the application is having trouble with tracking the transaction status.</div>',
            showCancelButton: true,
            width: 600,
            confirmButtonText: 'Check again'
          });
        case 11:
          result = _context24.sent;
          if (!result.isConfirmed) {
            _context24.next = 18;
            break;
          }
          _context24.next = 15;
          return saveTx(apiHost, accessToken, method, data, disableDialog);
        case 15:
          return _context24.abrupt("return", _context24.sent);
        case 18:
          error(res.data.msg);
        case 19:
          _context24.next = 31;
          break;
        case 21:
          _context24.prev = 21;
          _context24.t0 = _context24["catch"](1);
          _context24.next = 25;
          return sweetalert2_1.default.fire({
            html: '<div style=\'text-align: left;\'>The transaction was submitted successfully, but the application is having trouble with tracking the transaction status.</div>',
            showCancelButton: true,
            width: 600,
            confirmButtonText: 'Check again'
          });
        case 25:
          _result = _context24.sent;
          if (!_result.isConfirmed) {
            _context24.next = 30;
            break;
          }
          _context24.next = 29;
          return saveTx(apiHost, accessToken, method, data, disableDialog);
        case 29:
          return _context24.abrupt("return", _context24.sent);
        case 30:
          return _context24.abrupt("return", null);
        case 31:
          return _context24.abrupt("return", null);
        case 32:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[1, 21]]);
  }));
}